/**
 * Reports Index
 * Card grid linking to each report, like SettingsIndexPage. Customer
 * statements are reached from a customer's page or the AR aging report.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { REPORT_ITEMS } from './reportUi';

export function ReportsIndexPage() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Reports</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORT_ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="block rounded-lg border border-gray-200 bg-white p-5 shadow-sm transition hover:border-blue-300 hover:shadow-md"
          >
            <h2 className="text-base font-semibold text-gray-900">{item.label}</h2>
            <p className="mt-1 text-sm text-gray-500">{item.description}</p>
          </Link>
        ))}
        <div className="rounded-lg border border-dashed border-gray-300 bg-white/60 p-5">
          <h2 className="text-base font-semibold text-gray-900">Customer statement</h2>
          <p className="mt-1 text-sm text-gray-500">
            What does this customer's account look like? Open a customer and choose <strong>Statement</strong>,
            or click a customer name in <Link to="/reports/ar-aging" className="text-blue-700 hover:underline">AR aging</Link>.
          </p>
        </div>
      </div>
    </main>
  );
}
